export default "__VITE_ASSET__DgL9P9fR__"